import { useEffect, useState } from 'react';

export default function Navbar() {
  const [isBlogDropdownOpen, setIsBlogDropdownOpen] = useState(false);

  useEffect(() => {
    const urlParams = window.location.search;
    const loginLink = document.getElementById('loginLink') as HTMLAnchorElement;

    if (urlParams && loginLink) {
      const cleanParams = urlParams.startsWith('?') ? urlParams.substring(1) : urlParams;
      const linkUrl = new URL(loginLink.href);
      linkUrl.search = cleanParams;
      loginLink.href = linkUrl.toString();
    }
  }, []);

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 backdrop-blur-lg bg-[#081428]/80 border-b border-white/10">
      <div className="container mx-auto px-6">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <a href="/" className="flex items-center">
            <img 
              src="https://imagedelivery.net/xVIHcLAprA3z5a44SkpIlA/bae752f2-e9b0-4924-58be-186e7e7c0c00/public" 
              alt="LawX Logo" 
              className="h-8 w-auto"
            />
          </a>

          {/* Navigation Links */}
          <div className="hidden md:flex items-center space-x-8">
            <a href="#tools" className="text-gray-300 hover:text-[#28E7C5] transition-colors">
              Ferramentas
            </a>
            <a href="#compare" className="text-gray-300 hover:text-[#28E7C5] transition-colors">
              LawX vs ChatGPT
            </a>
            <div className="relative">
              <button 
                onClick={() => setIsBlogDropdownOpen(!isBlogDropdownOpen)}
                className="text-gray-300 hover:text-[#28E7C5] transition-colors flex items-center"
              >
                Blog
                <svg 
                  className={`ml-1 h-4 w-4 transition-transform ${isBlogDropdownOpen ? 'rotate-180' : ''}`} 
                  fill="none" 
                  stroke="currentColor" 
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </button>
              {isBlogDropdownOpen && (
                <div className="absolute top-full mt-2 w-48 bg-[#081428] border border-white/10 rounded-md shadow-lg">
                  <a href="https://blog.lawx.ai/category/como-usar-ia/" className="block px-4 py-2 text-gray-300 hover:bg-[#28E7C5]/10 hover:text-[#28E7C5]">
                    Como usar IA
                  </a>
                  <a href="https://blog.lawx.ai/category/dicas-de-uso/" className="block px-4 py-2 text-gray-300 hover:bg-[#28E7C5]/10 hover:text-[#28E7C5]">
                    Dicas de Uso
                  </a>
                  <a href="https://blog.lawx.ai/category/direito-civil/" className="block px-4 py-2 text-gray-300 hover:bg-[#28E7C5]/10 hover:text-[#28E7C5]">
                    Direito Civil
                  </a>
                  <a href="https://blog.lawx.ai/category/direito-do-trabalho/" className="block px-4 py-2 text-gray-300 hover:bg-[#28E7C5]/10 hover:text-[#28E7C5]">
                    Direito do Trabalho
                  </a>
                  <a href="https://blog.lawx.ai/category/direito-ia/" className="block px-4 py-2 text-gray-300 hover:bg-[#28E7C5]/10 hover:text-[#28E7C5]">
                    Direito IA
                  </a>
                  <a href="https://blog.lawx.ai/category/direito-penal/" className="block px-4 py-2 text-gray-300 hover:bg-[#28E7C5]/10 hover:text-[#28E7C5]">
                    Direito Penal
                  </a>
                  <a href="https://blog.lawx.ai/category/direito-tributario/" className="block px-4 py-2 text-gray-300 hover:bg-[#28E7C5]/10 hover:text-[#28E7C5]">
                    Direito Tributário
                  </a>
                  <a href="https://blog.lawx.ai/category/geral/" className="block px-4 py-2 text-gray-300 hover:bg-[#28E7C5]/10 hover:text-[#28E7C5]">
                    Geral
                  </a>
                  <a href="https://blog.lawx.ai/category/inteligencia-artificial/" className="block px-4 py-2 text-gray-300 hover:bg-[#28E7C5]/10 hover:text-[#28E7C5]">
                    Inteligência Artificial
                  </a>
                </div>
              )}
            </div>
            <a 
              id="loginLink"
              href="https://plataforma.lawx.ai/dashboard" 
              className="text-gray-300 hover:text-[#28E7C5] transition-colors"
            >
              Login
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
}